import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignaturePopoverComponent } from './signature-popover.component';
import { IconModule } from 'src/app/components/icon/icon.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [SignaturePopoverComponent],
  exports: [SignaturePopoverComponent],
  imports: [CommonModule, IconModule, SharedModule],
})
export class SignaturePopoverModule {}
